import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import Select from 'react-select';

class ComparisonLinkTypeSelector extends Component {
  render() {
    const { t, onChange, placeholder, value } = this.props;
    const options = [
      { value: 'and', label: t('comparisonLinkType.and') },
      { value: 'or', label: t('comparisonLinkType.or') },
    ];
    return (
      <Select
        value={options.find((option) => option.value === value)}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        noOptionsMessage={() => t('noOptions')}
      />
    );
  }
}

export default withTranslation('translation')(ComparisonLinkTypeSelector);
